export const AUTH_TOKEN_STORAGE_KEY = "AUTH_TOKEN" as const;

export function getStoredAuthToken(): string | null {
  const raw = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (raw == null) return null;
  const trimmed = raw.trim();
  if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
    return null;
  }
  return trimmed;
}

export function getAuthHeaders(): Record<string, string> {
  const token = getStoredAuthToken();
  return token ? { authorization: `JWT ${token}` } : {};
}
